<template>
  <div>
    <v-hover
      v-slot="{ hover }"
      >
      <div
        class="d-flex align-center"
        style="overflow-x: hidden; position: relative"
        >
        <div
          style="position: absolute; left: 0"
          :style="hover ? 'transform: translateX(0px)' : 'transform: translateX(-34px)'"
          >
          <delete-sub-account
            :subAccount="subAccount"
            @reload="$emit('reload')"
            ></delete-sub-account>
        </div>
        <v-row
          class="background grow"
          :style="hover ? 'transform: translateX(34px)' : 'translateX(0)'"
          style="width: 100%; cursor: pointer"
          @click="expand = !expand"
          >
          <v-col
            class="text-subtitle-1 font-weight-medium primary--text py-2"
            cols="7"
            >
            {{ subAccount.name }}
          </v-col>

          <v-col
            cols="2"
            class="text-subtitle-1 text-center py-2"
            >
            ARS
          </v-col>

          <v-col
            cols="3"
            class="text-right text-subtitle-1 py-2"
            :class="subAccount.tmpBalance >= 0 ? '' : 'red--text'"
            >
            $ {{ subAccount.parsedBalance }}
          </v-col>
        </v-row>
      </div>
    </v-hover>

    <v-expand-transition>
      <div
        v-if="expand"
        >
        <template
          v-for="concept in subAccount.concepts"
          >
          <v-hover
            v-slot="{ hover }"
            >
            <div
              class="d-flex align-center"
              style="overflow-x: hidden; position: relative"
              >
              <div
                style="position: absolute; left: 0"
                :style="hover ? 'transform: translateX(0px)' : 'transform: translateX(-34px)'"
                >
                <delete-concept
                  :concept="concept"
                  @reload="$emit('reload')"
                  ></delete-concept>
              </div>
              <v-row
                :style="hover ? 'transform: translateX(34px)' : 'translateX(0)'"
                >
                <v-col
                  class="primary--text py-1"
                  cols="7"
                  >
                  {{ concept.name }}
                </v-col>

                <v-col
                  cols="2"
                  class="text-center py-1"
                  >
                </v-col>

                <v-col
                  cols="3"
                  class="text-right py-1"
                  :class="concept.balance >= 0 ? '' : 'red--text'"
                  >
                  $ {{ concept.parsedBalance }}
                </v-col>
              </v-row>
            </div>
          </v-hover>
        </template>

        <v-row>
          <v-col
            cols="12"
            >
            <create-concept
              :subAccount="subAccount"
              @reload="$emit('reload')"
              ></create-concept>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
const CreateConcept = () => import('@/components/balances/concepts/Create')
const DeleteSubAccount = () => import('@/components/balances/sub_accounts/Delete')
const DeleteConcept = () => import('@/components/balances/concepts/Delete')

export default {
  data: () => ({
    expand: false
  }),

  props: {
    subAccount: {
      required: true,
      type: Object
    }
  },

  components: {
    CreateConcept,
    DeleteConcept,
    DeleteSubAccount,
  }
}
</script>
